module.exports = __webpack_public_path__ + "media/bootstrap-icons/text-paragraph-13e28613.svg";